import React from "react";
import FAQAccordion from '../FAQAccordion';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

 render() {
  return (
    <React.Fragment>
      <section id="info-wildlife-hiking" className="about-us pt-trip gray-light-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div>
              <div className="section-heading mb-5 mx-2">
                {this.props.showTitle && this.props.showTitle === true && (
                  <span className="badge badge-primary badge-pill">
                    Wildlife Hiking Safety
                  </span>
                )}
                <h1 className="text-center">
                  How to Protect Yourself from Wildlife While Hiking (Complete Beginner Guide)
                  <br />
                </h1>

                <p>
                  Wildlife encounters are one of the most exciting parts of hiking, but they can also feel intimidating if you are not prepared.
                </p>

                <p>
                  The reality is that most wildlife does not want anything to do with humans. Dangerous encounters usually happen when animals feel surprised, threatened, or attracted to food.
                </p>

                <p>
                  The good news is that with the right knowledge and a few simple habits, you can significantly reduce your risk and hike with confidence.
                </p>

                <p>
                  In this guide, you will learn how to protect yourself from wildlife while hiking, including how to prepare before your hike, how to behave on the trail, and what to do if you encounter an animal.
                </p>

                <p>
                  If you are planning your next hike, check out our guide on <a className="in-text-link" href="/how-to-use-hiking-poles-correctly">
                    How to Use Hiking Poles Correctly
                  </a> to improve your stability and confidence on the trail.
                </p>
                <FAQAccordion
                  title="Wildlife Safety While Hiking FAQs"
                  items={[
                    { q: 'What should you do if you encounter a bear while hiking?', a: 'Stay calm, do not run. Speak in a calm, low voice. Make yourself look large. Back away slowly while facing the bear. Deploy bear spray if it charges — practice drawing it before your trip.' },
                    { q: 'What is the difference between a black bear and grizzly bear encounter?', a: 'With black bears, fight back if attacked — they are usually deterred by aggression. With grizzlies, play dead (face down, hands protecting neck) for a defensive attack. Fight back against a predatory grizzly attack that continues.' },
                    { q: 'How far should you stay from wildlife in national parks?', a: 'The standard NPS guideline is 100 yards from bears and wolves, and 25 yards from other wildlife like bison, elk, and deer. If an animal changes behavior, you are too close.' },
                    { q: 'Does bear spray actually work?', a: 'Yes — research shows bear spray is more effective than firearms at stopping a bear charge. It works at 15–30 feet, creating a cloud the bear must walk through. Carry it in a hip holster, not in your pack.' },
                    { q: 'How do you avoid mountain lion encounters while hiking?', a: 'Hike in groups, make noise, keep children close, and avoid hiking at dawn, dusk, or night when mountain lions are most active. If you see one, do not run — make yourself large, maintain eye contact, and back away slowly.' },
                    { q: 'How do you protect food from bears when camping?', a: 'Use a bear canister or hang food in a bear bag at least 10 feet off the ground and 4 feet from the trunk. Never keep food in your tent. In areas with food storage regulations, a hard-sided canister is required.' },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
}
export default About;